import { applyService } from "@/service"
import ActionId from "@/action/ActionId"
import BaseFullApplyAction from "@/action/actions/BaseFullApplyAction"

class SubmitFullApplyAction extends BaseFullApplyAction {

    #application = null

    constructor(providerKey, application) {
        super(ActionId.SUBMIT_FULL_APPlY, providerKey)
        this.#application = application
    }

    async _submit() {
        return applyService.apply(this.providerKey, {
            application: this.#application,
        })
    }
}

export default SubmitFullApplyAction
